<template>
    <div>
        <div>
            <navigation-menu />
        </div>
    </div>
</template>

<script>
    import WebChatList from './WebChatList';
    import WebChatGroupList from './WebChatGroupList';

    import VueRouter from 'vue-router';

    const router = new VueRouter({
        routes: [
            { path: '/webchat-list', component: WebChatList, label: 'Webchat'},
            { path: '/webchat-group-list', component: WebChatGroupList, label: 'Webchat Groups'},
            { path: '/', redirect: '/webchat-list' },
        ],
        linkActiveClass: 'active',
        linkExactActiveClass: 'exact-active',
    });

    export default {
        router,
    }
</script>
